import { render, staticRenderFns } from "./moneyReward.vue?vue&type=template&id=11025da1&scoped=true&"
import script from "./moneyReward.vue?vue&type=script&lang=js&"
export * from "./moneyReward.vue?vue&type=script&lang=js&"
import style0 from "./moneyReward.vue?vue&type=style&index=0&id=11025da1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11025da1",
  null
  
)

component.options.__file = "moneyReward.vue"
export default component.exports